/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Process instance state
 */
export enum ProcessInstanceState {
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}
